import CustomError from './CustomError'

export default class ForbiddenPortalRequested extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
